import React, { FunctionComponent } from 'react';
import styles from './Tag.scss';

export const Tag: FunctionComponent = ({ children }) => (
  <span className={`${styles.tag} jg-text--xsmall`}>{children}</span>
);
